import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dayCheckbox", "timeSlotsContainer", "timeSlots", "timeSlot", "timeInput"]
  static values = { 
    fieldName: String
  }

  connect() {
    // Initialiser l'état des jours
    this.dayCheckboxTargets.forEach(checkbox => {
      this.updateDayVisibility(checkbox)
    })
  }

  toggleDay(event) {
    this.updateDayVisibility(event.target)
  }

  updateDayVisibility(checkbox) {
    console.log(`Toggling day: ${checkbox.dataset.day}`)
    const day = checkbox.dataset.day
    const container = this.element.querySelector(`[data-schedule-form-target="timeSlotsContainer"][data-day="${day}"]`)
    
    if (container) {
      console.log(checkbox)
      console.log(checkbox.checked ? `Enabling day: ${day}` : `Disabling day: ${day}`)
      if (checkbox.checked) {
        container.classList.remove('opacity-50')
        container.querySelectorAll('input').forEach(input => input.disabled = false)
        
        // S'assurer qu'il y a au moins un créneau quand on active un jour
        const timeSlots = container.querySelector('[data-schedule-form-target="timeSlots"]')
        if (timeSlots && timeSlots.children.length === 0) {
          this.addTimeSlotForDay(day)
        }
      } else {
        container.classList.add('opacity-50')
        container.querySelectorAll('input').forEach(input => input.disabled = true)
      }
    }
  }

  addTimeSlot(event) {
    event.preventDefault()
    const button = event.currentTarget // Utiliser currentTarget pour la cohérence
    const day = button.dataset.day
    this.addTimeSlotForDay(day)
  }

  addTimeSlotForDay(day) {
    const timeSlots = this.element.querySelector(`[data-schedule-form-target="timeSlots"][data-day="${day}"]`)
    if (!timeSlots) return

    const index = timeSlots.children.length
    const timeSlotHtml = this.createTimeSlotHtml(day, index, "09:00", "17:00")
    
    timeSlots.insertAdjacentHTML('beforeend', timeSlotHtml)
  }

  removeTimeSlot(event) {
    event.preventDefault()
    const button = event.currentTarget // Utiliser currentTarget au lieu de target
    const day = button.dataset.day
    const index = parseInt(button.dataset.index)
    
    console.log(`Removing time slot for day: ${day}, index: ${index}`)
    
    const timeSlots = this.element.querySelector(`[data-schedule-form-target="timeSlots"][data-day="${day}"]`)
    if (!timeSlots) {
      console.log(`No timeSlots container found for day: ${day}`)
      return
    }
    
    const timeSlotElements = timeSlots.querySelectorAll('[data-schedule-form-target="timeSlot"]')
    console.log(`Found ${timeSlotElements.length} time slot elements`)
    
    // Ne pas supprimer s'il n'y a qu'un seul créneau et que le jour est activé
    const dayCheckbox = this.element.querySelector(`[data-schedule-form-target="dayCheckbox"][data-day="${day}"]`)
    if (timeSlotElements.length <= 1 && dayCheckbox && dayCheckbox.checked) {
      console.log("Cannot remove: only one slot and day is enabled")
      return
    }
    
    if (timeSlotElements[index]) {
      console.log(`Removing element at index ${index}`)
      timeSlotElements[index].remove()
      this.reindexTimeSlotsForDay(day)
    } else {
      console.log(`No element found at index ${index}`)
    }
  }

  reindexTimeSlotsForDay(day) {
    const timeSlots = this.element.querySelector(`[data-schedule-form-target="timeSlots"][data-day="${day}"]`)
    if (!timeSlots) return

    const timeSlotElements = timeSlots.querySelectorAll('[data-schedule-form-target="timeSlot"]')
    
    timeSlotElements.forEach((element, newIndex) => {
      // Mettre à jour les noms des inputs
      const inputs = element.querySelectorAll('input')
      inputs.forEach(input => {
        const name = input.name
        if (name) {
          const newName = name.replace(/\[time_slots\]\[\d+\]/, `[time_slots][${newIndex}]`)
          input.name = newName
        }
      })
      
      // Mettre à jour les data-index des boutons
      const removeButton = element.querySelector('button[data-action*="removeTimeSlot"]')
      if (removeButton) {
        removeButton.dataset.index = newIndex
      }
    })
  }

  createTimeSlotHtml(day, index, startTime, endTime) {
    return `
      <div class="flex items-center space-x-3 mb-3 p-3 bg-gray-50 rounded-lg" data-schedule-form-target="timeSlot">
        <div class="flex-1 grid grid-cols-2 gap-3">
          <div>
            <label class="block text-sm/6 font-medium text-gray-900 mb-2">Début</label>
            <input type="time" 
                   name="${this.fieldNameValue}[${day}][time_slots][${index}][start_time]"
                   value="${startTime}"
                   class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-200 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-sz-primary-600 sm:text-sm/6"
                   data-schedule-form-target="timeInput"
                   data-action="change->schedule-form#validateTimeSlot"
                   required>
          </div>
          
          <div>
            <label class="block text-sm/6 font-medium text-gray-900 mb-2">Fin</label>
            <input type="time" 
                   name="${this.fieldNameValue}[${day}][time_slots][${index}][end_time]"
                   value="${endTime}"
                   class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-200 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-sz-primary-600 sm:text-sm/6"
                   data-schedule-form-target="timeInput"
                   data-action="change->schedule-form#validateTimeSlot"
                   required>
          </div>
        </div>
        
        <button type="button" 
                class="inline-flex items-center p-2 border border-transparent rounded-md text-red-600 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                data-action="click->schedule-form#removeTimeSlot"
                data-day="${day}"
                data-index="${index}"
                title="Supprimer ce créneau">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    `
  }

  validateTimeSlot(event) {
    const input = event.target
    const container = input.closest('[data-schedule-form-target="timeSlot"]')
    if (!container) return
    
    const startInput = container.querySelector('input[name*="[start_time]"]')
    const endInput = container.querySelector('input[name*="[end_time]"]')
    
    if (startInput && endInput && startInput.value && endInput.value) {
      const startTime = new Date(`2000-01-01T${startInput.value}:00`)
      const endTime = new Date(`2000-01-01T${endInput.value}:00`)
      
      if (endTime <= startTime) {
        endInput.setCustomValidity('L\'heure de fin doit être après l\'heure de début')
        endInput.reportValidity()
        return false
      } else {
        endInput.setCustomValidity('')
      }
    }
    
    return true
  }
}
